module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canAdd) ? _c('button', {
    staticClass: "cart-btn",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("Add to Cart")]) : _c('span', [_c('button', {
    staticClass: "cart-btn remove-btn",
    staticStyle: {
      "background": "#e05024"
    },
    on: {
      "click": function($event) {
        _vm.removeFromCart(_vm.productItem)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Remove from Cart")]), _vm._v(" "), _c('button', {
    staticClass: "cart-btn view-btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-911a44d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductCartActions.vue
// module id = 293
// module chunks = 0